// vuex
// 引入vue
import Vue from "vue";
// 引入vuex
import Vuex from "vuex";

// 引入axios
import axios from "axios";

// 安装vuex
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    questionsTitle: "",
    questionsInfo: "",
    questionsTime: "",
    questionsAuthor: "",
    productName: "",
    productStatus: "",
    productImgUrl: "",
    tableData: [],
    chosenData: [],
    productNum: "",
    productMoney: "",
    shoppingcart: "",
  },
  //事件处理
  mutations: {
    async RenderQuestions(state, id) {
      const res = await axios({
        url: "owsArticle/findArticleById",
        method: "post",
        params: {
          articleId: id,
        },
      });
      state.questionsTitle = res.data.data.code.title;
      state.questionsInfo = res.data.data.code.content;
      state.questionsTime = res.data.data.code.isAddTime;
      state.questionsAuthor = res.data.data.code.author;
      sessionStorage.setItem(
        "QUESTIONS_TIME",
        JSON.stringify(res.data.data.code.isAddTime)
      );
      sessionStorage.setItem(
        "QUESTIONS_AUTHOR",
        JSON.stringify(res.data.data.code.author)
      );
      sessionStorage.setItem(
        "questionsTitle",
        JSON.stringify(res.data.data.code.title)
      );
      sessionStorage.setItem(
        "questionsContent",
        JSON.stringify(res.data.data.code.content)
      );
    },
    async getProductInfo(state, id) {
      const res = await axios({
        url: "/owsProductInfo/findProductInfoById",
        method: "post",
        params: {
          id: id,
        },
      });
      if (res.data.retCode === 200) {
        state.productName = res.data.data.code.name;
        state.productStatus = res.data.data.code.ogiStatus;
        state.productImgUrl = res.data.data.code.productImg;
        sessionStorage.setItem("productName", res.data.data.code.name);
        sessionStorage.setItem("productStatus", res.data.data.code.ogiStatus);
        sessionStorage.setItem("productImgUrl", res.data.data.code.productImg);
        sessionStorage.setItem("productId", res.data.data.code.id);
      } else if (res.data.retCode !== 200 && res.data.retCode !== 500103) {
        return false;
      }
    },
    async getShoppingCart(state) {
      const res = await axios({
        url: "/osc/findOmsShoppingCartAll",
        method: "post",
        params: {
          userId: localStorage.getItem("userId"),
        },
      });
      state.tableData = res.data.data.code;
      state.shoppingcart = res.data.data.code.length;
    },
    toAccounts(state, chosen) {
      state.chosenData = chosen;
      let price = 0;
      state.chosenData.forEach((item) => {
        if (item.goods_num === undefined || item.goods_num < 1) {
          item.goods_num = 1;
        }
        price += Number(item.outer_goods_price * item.goods_num);
      });
      state.productMoney = price.toFixed(2);
      sessionStorage.setItem("PRODUCT_NUM", state.chosenData.length);
    },
  },
  // 计算属性
  getters: {
    getProductNum(state) {
      state.productNum = sessionStorage.getItem("PRODUCT_NUM");
      return state.productNum;
    },
    getProcuctMoney(state) {
      return (state.productMoney = sessionStorage.getItem("PRODUCT_MONEY"));
    },
    getProcuctGName(state) {
      return sessionStorage.getItem("product_GoodNM");
    },
  },
});
